export default __webpack_public_path__ + "static/media/ltr-sb-img.779d36cd.webp";